const styles = theme => ({
  header: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%;' /* 18px */,
  },
  headerOverlay: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%;' /* 18px */,
    padding: '8px 8px 8px 0',
    width: '140px',
  },
  background: {
    display: 'flex',
    padding: '4px',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
  },
  button: {
    width: '66.67',
    borderRadius: '4px',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  row: {
    display: 'grid',
    gap: '4px',
  },
  box: {
    display: 'grid',
    gap: '12px',
  },
  container: {
    maxHeight: '60vh', // Reduced from 80vh to ensure scroll is visible
    overflowX: 'hidden',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px', // Increased from 4px for better visibility
    },
    '&::-webkit-scrollbar-track': {
      background: '#F4F6F8',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD5E0', // Always visible
      borderRadius: '4px',
      '&:hover': {
        background: '#A0AEC0',
      },
    },
  },
  popover: {
    zIndex: '99999 !important',
  },
  pickerBg: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    width: 36,
    height: 36,
    background: '#f2f2f2',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  pickerSpan: {
    width: 24,
    height: 24,
    borderRadius: '10px',
    background: 'red',
  },
  boxIconButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: '1 0 0',
  },
  boxSourceButton: {
    display: 'flex',
    height: '100px',
    padding: '20px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
    cursor: 'pointer',
  },
  boxSourceImage: {
    display: 'flex',
    height: '100px',
    width: '200px',
    position: 'relative', // Add this line
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
  },
  boxIcon: {
    display: 'flex',
    width: '24px',
    height: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: '0',
    borderRadius: '6px',
    background: 'var(--mcg-bg, #F4F6F8)',
    '& svg': {
      width: '18.5px',
      height: '18.5px',
      display: 'block',
      '& path': {
        width: '100%',
        height: '100%',
      },
    },
  },
  uploadText: {
    display: 'flex',
    height: '24px',
    flexDirection: 'column',
    justifyContent: 'center',
    flexShrink: '0',
    alignSelf: 'stretch',
    color: 'var(--Gray-Darker, #838D98)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  logoText: {
    display: 'flex',
    height: '24px',
    flexDirection: 'column',
    justifyContent: 'center',
    flexShrink: '0',
    alignSelf: 'stretch',
    color: 'var(--Gray-Darker, #838D98)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%' /* 18px */,
  },
  sourceImage: {
    display: 'flex',
    height: '100px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderRadius: '6px',
    background: 'url(<path-to-image>) lightgray 50% / cover no-repeat',
  },
  sourceIcon: {
    position: 'absolute',
    top: '5px', // Adjust this value as needed
    right: '5px', // Adjust this value as needed
    padding: '3px',
    borderRadius: '4px',
    background: 'var(--mcg-white, #FFF)',
    width: '20px',
    height: '20px',
    cursor: 'pointer',
    zIndex: 1, // Add this to ensure icon appears above the image
  },
  backgroudPosition: {
    display: 'flex',
    justifyContent: 'center',
  },
  overlay: {
    display: 'flex',
  },
  divider: {
    height: '1px',
    background: '#E5E7EB',
  },
  select: {
    '& .MuiSelect-root': {
      padding: '8px 12px',
    },
  },
  menuItemTitle: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '150%',
  },
  menuItemDesc: {
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    marginTop: '2px',
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  radioTitle: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  radioDesc: {
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
    marginTop: '2px',
  },
  communityRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
  communityLabelContainer: {
    minWidth: '120px',
  },
  communitySelect: {
    flex: 1,
    minWidth: '120px',
  },
  communityHelpText: {
    marginTop: '-8px',
    marginBottom: '4px',
  },
  helpText: {
    color: 'var(--mcg-gray, #919EAB)',
    fontFamily: 'Inter',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '150%',
  },
  badgeInput: {
    width: '100%',
    padding: '8px 12px',
    border: '1px solid #DFE3E8',
    borderRadius: '8px',
    fontSize: '14px',
    fontFamily: 'Inter',
    outline: 'none',
    color: '#002E47',
    boxSizing: 'border-box',
    '&:focus': {
      borderColor: '#015FFB',
    },
  },
})

export default styles
